import type { ThreadCreatedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import SettingsIcon from "@redotech/redo-icons/settings-02.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const ThreadCreatedEvent = memo(function ThreadCreatedEvent({
  event,
  data,
}: {
  event: ConversationTimelineEventResponse;
  data: ThreadCreatedEventData;
}) {
  return (
    <Flex align="flex-start" className={styles.card} dir="row" gap="sm">
      <div className={styles.icon}>
        <SettingsIcon />
      </div>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs">Thread created on {data.channel}</Text>
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
